"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formStatuses = void 0;
exports.formStatuses = {
    processed: 'is-processed',
};
